import { useOptionalNotificationsSessionContext } from '../session/useNotificationsSessionContext';
import { useNotificationsTourDemoStore } from '../tour/notifications-tour-demo.store';
import { NotificationFeedEmptyState } from './list/NotificationFeedEmptyState';
import { NotificationsFeed } from './NotificationsFeed';
import { NotificationsFeedTourDemo } from './NotificationsFeedTourDemo';

/**
 * Chooses tour demo, live feed, or empty when Knock is unavailable.
 */
export function NotificationsFeedContent() {
  const session = useOptionalNotificationsSessionContext();
  const tourDemoActive = useNotificationsTourDemoStore((state) => state.active);

  if (tourDemoActive) {
    return <NotificationsFeedTourDemo />;
  }

  if (!session?.isKnockReady) {
    return <NotificationFeedEmptyState />;
  }

  return <NotificationsFeed />;
}
